import { action, makeObservable, observable } from "mobx";
import { postApi } from "../components/Utility";
import conf from "../config";

class HeatMapStore {
  vehicleArray = [];
  heatMapArray = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicleArray: observable,
      heatMapArray: observable,
      getVehicle: action,
    });
    this.rootStore = rootStore;
  }

  async getVehicle(data) {
    // var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //       .getClient()
    //       .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: data });
    this.vehicleArray = response.data?.vehicleData;
  }

  async getHeatMapData(data) {
    this.heatMapArray = [];
    // var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //       .getClient()
    //       .post("index.php?c=map&a=heatmap", "postData=" + base64Input);

    // const base64Input = await base64_encode(JSON.stringify(postData));
    if (conf.currentFlavor == "awtltrack" || conf.currentFlavor == "local") {
      var response = await postApi
        .getClient("report")
        .get("/heatmap/heatmapByCH", { params: data });
    } else {
      var response = await postApi
        .getClient("NodeCoreUrl")
        .get("heatmap/getdata", { params: data });
    }

    let heatMapArr = [];
    await response.data?.heatmapdata.forEach((val) =>
      heatMapArr?.push({
        lat: parseFloat(val.latitude),
        lng: parseFloat(val.longitude),
      })
    );
    this.heatMapArray = heatMapArr;
    return this.heatMapArray.length;
  }
}

export default HeatMapStore;
